import { HOME_DATA_PAGE_SIZE } from "../SHARED/hooks/useHomeDataBase";

export function buildLawFirmBondsFeedUrl(page, pageSize, lawFirmId) {
  return `/bonds-feed/?lawfirm_id=${lawFirmId}&page=${page}&page_size=${pageSize}`;
}

export function buildLawFirmMissingIndemnityUrl(lawFirmId) {
  return `/missing-indemnity-bonds?lawfirm_id=${lawFirmId}`;
}

export function buildLawFirmDraftsUrl(lawFirmId) {
  return `/bond-cache-lawfirm/${lawFirmId}/`;
}

export const LAW_FIRM_HOME_URL_BUILDERS = {
  pageSize: HOME_DATA_PAGE_SIZE,
  buildBondsFeedUrl: buildLawFirmBondsFeedUrl,
  buildMissingIndemnityUrl: buildLawFirmMissingIndemnityUrl,
  buildDraftsUrl: buildLawFirmDraftsUrl,
};
